import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Block8 {
  static selector = ".block-8";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.imageTemplate = this.block.querySelector("#block-8__image-template");
    this.imagesNode = this.block.querySelector(".block-8__images");
    this.textNode = this.block.querySelector(".block-8__caption .text");
    this.creditsNode = this.block.querySelector(".block-8__caption .credits");
    this.captionNode = this.block.querySelector(".block-8__caption");

    this.attributes = attrs;
  }

  setupImage = async (item) => {
    return new Promise(async (resolve) => {
      const node = this.imageTemplate.content.firstElementChild.cloneNode(true);
      if (node) {
        const imageNode = node.querySelector(".image");
        await new CustomImage(imageNode, item.image).onReady();

        const captionNode = node.querySelector(
          ".block-8__images__image__caption"
        );
        if (item.text || item.credits) {
          if (item.text) {
            await new Text(
              captionNode.querySelector(".text"),
              item.text
            ).onReady();
          }

          if (item.credits) {
            await new Credits(
              captionNode.querySelector(".credits"),
              item.credits
            ).onReady();
          }
        } else {
          captionNode.remove();
        }

        resolve(node);
      } else {
        reject(false);
      }
    });
  };

  setupImages = () => {
    this.attributes.images.forEach(async (image) => {
      const imageNode = await this.setupImage(image);
      if (imageNode) {
        this.imagesNode.appendChild(imageNode);
      }
    });
  };

  setup = async () => {
    return new Promise(async (resolve) => {
      if (this.attributes.text) {
        await new Text(this.textNode, this.attributes.text).onReady();
      }

      if (this.attributes.credits) {
        await new Credits(this.creditsNode, this.attributes.credits).onReady();
      }

      this.setupImages();
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
